/**
 * ExamEnrollment scene sagas
 *
 * @author Diogo Guedes <dguedes@ubiwhere.com>
 *
 */

import { takeLatest, put } from 'redux-saga/effects';
import { actions } from 'store/rootSlices';

function* onMountSaga() {
  yield put(actions.SpecialExams.setLoading(false));
}

function* onUnmountSaga() {}

export default function* watcherSignin() {
  yield takeLatest('SpecialExams/onMount', onMountSaga);
  yield takeLatest('SpecialExams/onUnmount', onUnmountSaga);
}
